import { profile, validValues } from "./profile";

const baseUrl = 'http://localhost/Schedulapp/src';
const webserviceMainPath = '/ws/webservice.php?service=';
const imageUploadsMainPath = '/ws/imageUploads.php';
export const configUrl = '/cfg/config.json?v=1';
export const isDevelopment = (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");
export const API = isDevelopment ? baseUrl + webserviceMainPath : webserviceMainPath;
export const IMAGE_UPLOADS = isDevelopment ? baseUrl + imageUploadsMainPath : webserviceMainPath;

export const LOGIN_LEVELS = {
    SA: 0,
    ADMIN: 1,
    MANAGER: 2,
    USER: 3,
    VIEWER: 4,
};

export const PERMISSION_LEVELS = {
    EDIT: 1,
    VIEW: 2,
};

export const FAST_ANIMATION = 200;

export const profileOptions = profile;
export const possibleValues = validValues;
